import { useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";

export function usePublish(
  buildUrl: (val: number) => string,
  refetchKey: string,
  onSuccess?: (val: number, data: any) => void,
) {
  const queryClient = useQueryClient();

  return useCallback(
    (val: number) => {
      let responseData: any;

      fetch(buildUrl(val), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({}),
        credentials: "include",
      })
        .then((r) => {
          if (!r.ok) throw new Error(`HTTP error! status: ${r.status}`);

          return r.json();
        })
        .then((data) => {
          responseData = data;

          return queryClient.refetchQueries({ queryKey: [refetchKey] });
        })
        .then(() => onSuccess?.(val, responseData))
        .catch((e) => console.error("Error:", e));
    },
    [buildUrl, refetchKey, queryClient, onSuccess],
  );
}
